import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ProgramPage = () => {
  return (
    <>
      <title>Bilimsel Program | İstanbul Dental Kongresi 2026</title>
      <meta name="description" content="İstanbul Dental Kongresi 2026 bilimsel programı. 2-3 Mayıs 2026 tarihlerinde implantoloji, ortodonti ve diş hekimliği alanında teorik oturumlar ve uygulamalı kurslar." />
      <meta name="keywords" content="istanbul dental kongresi program, diş hekimliği bilimsel program, dental kongre 2026 oturumlar" />
      <link rel="canonical" href="https://ankaradentalkongresi.com/program" />
      <meta property="og:title" content="Bilimsel Program | İstanbul Dental Kongresi 2026" />
      <meta property="og:description" content="2-3 Mayıs 2026 tarihlerinde implantoloji, ortodonti ve diş hekimliği alanında teorik oturumlar ve uygulamalı kurslar." />
      <meta property="og:url" content="https://ankaradentalkongresi.com/program" />
      <div className="min-h-screen flex flex-col">
        <Navbar />
        
        <main className="flex-1 bg-primary">
          <div className="min-h-[calc(100vh-80px)] flex items-center justify-center px-6 py-20">
            <div className="max-w-2xl mx-auto text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-accent/20 rounded-full mb-8">
                <i className="ri-calendar-line text-4xl text-accent"></i>
              </div>
              
              <h1 className="font-display text-5xl lg:text-6xl font-bold text-white mb-6">
                Bilimsel Program
              </h1>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
                <i className="ri-time-line text-5xl text-accent mb-4"></i>
                <p className="text-2xl text-white font-semibold mb-2">
                  Yakında Güncellenecektir
                </p>
                <p className="text-white/70">
                  Detaylı bilimsel program çok yakında yayınlanacaktır.
                </p>
              </div>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default ProgramPage;
